import { Injectable } from '@angular/core';
import { ConsentsService as WebConsentsService } from '@foo/foo-web-framework/shared-modules/consents';
@Injectable({
  providedIn: 'root'
})
export class ConsentsService extends WebConsentsService{
  constructor() {
    super();
  }

  override getPrefixedApi(api: string): string {
    let moduleName = 'internetBanking/';
    moduleName = moduleName ? moduleName.charAt(0).toLowerCase() + moduleName.slice(1) : '';
    return `${(!api.startsWith(moduleName)) ?  moduleName : ''}${api}`;
  }
}
